import { Dialog as Dialog$1 } from '@primer/react/deprecated';
import Box from '../Box.js';
import { forwardRef } from 'react';
import { jsx } from 'react/jsx-runtime';

const StyledDialog = /*#__PURE__*/forwardRef(function Dialog(props, ref) {
  return /*#__PURE__*/jsx(Box, {
    as: Dialog$1,
    ref: ref,
    ...props
  });
});
const DialogImpl = /*#__PURE__*/forwardRef(({
  as,
  ...props
}, ref) => /*#__PURE__*/jsx(StyledDialog, {
  ...props,
  ...(as ? {
    forwardedAs: as
  } : {}),
  ref: ref
}));
const StyledDialogHeader = /*#__PURE__*/forwardRef(function DialogHeader(props, ref) {
  return /*#__PURE__*/jsx(Box, {
    as: Dialog$1.Header,
    ref: ref,
    ...props
  });
});
const DialogHeader = /*#__PURE__*/forwardRef(({
  as,
  ...props
}, ref) => /*#__PURE__*/jsx(StyledDialogHeader, {
  ...props,
  ...(as ? {
    forwardedAs: as
  } : {}),
  ref: ref
}));
const Dialog = Object.assign(DialogImpl, {
  Header: DialogHeader
});

export { Dialog };
